module.exports = __webpack_public_path__ + "img/Kamer1.a799e435.jpg";